import React from 'react';
import { Field } from 'redux-form';
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';


const renderCheckbox = ({input, label, required = false, meta: { touched, error }}) => (
    <FormControlLabel
        control={
            <Checkbox
            checked={input.value}
            onChange={input.onChange}
            required={required}
            />
        }
        label={<p>{label}{required && <span>*</span>}{touched && <span style={{color: '#f44336'}}>{error}</span>}</p>}
    />
)
export default (obj) => {
    return <Field component={renderCheckbox} {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/checkbox.js